import { StrictDict } from 'utils';

import simpleSelectors from './simpleSelectors';
import appSelectors from './appSelectors';
import navSelectors from './navSelectors';
import courseCard from './courseCard';

export default StrictDict({
  ...simpleSelectors,
  ...appSelectors,
  ...navSelectors,
  courseCard,
});
